import { TrendingDownRounded, TrendingUpRounded } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import { useAmountsHidden } from '../privacy'

export const Stat = ({
  label,
  value,
  hint,
  tone: toneProp = 'default',
  inline = false,
}: {
  label: string
  value: string
  hint?: string
  tone?: 'default' | 'positive' | 'negative'
  /** label left, value right: for narrow screens */
  inline?: boolean
}) => {
  const hidden = useAmountsHidden()
  const tone = hidden ? 'default' : toneProp
  const color =
    tone === 'positive' ? 'success.main' : tone === 'negative' ? 'error.main' : 'text.primary'
  const TrendIcon =
    tone === 'positive' ? TrendingUpRounded : tone === 'negative' ? TrendingDownRounded : null

  if (inline) {
    return (
      <Stack
        direction="row"
        spacing={2}
        sx={{ px: 2, py: 1.25, justifyContent: 'space-between', alignItems: 'center' }}
      >
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {label}
        </Typography>
        <Stack sx={{ alignItems: 'flex-end', flexShrink: 0 }}>
          <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
            {TrendIcon && <TrendIcon sx={{ color, fontSize: 16 }} />}
            <Typography variant="subtitle1" sx={{ color, fontWeight: 700, lineHeight: 1.3 }}>
              {value}
            </Typography>
          </Stack>
          {hint && (
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {hint}
            </Typography>
          )}
        </Stack>
      </Stack>
    )
  }

  return (
    <Stack sx={{ flex: '1 1 0', minWidth: 110, overflowWrap: 'anywhere', px: { xs: 1.5, sm: 2 }, py: 1.5 }}>
      <Typography
        variant="overline"
        sx={{
          color: 'text.secondary',
          lineHeight: 1.2,
          fontSize: { xs: '0.7rem', sm: '0.75rem' },
          overflowWrap: 'anywhere',
        }}
      >
        {label}
      </Typography>
      <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
        {TrendIcon && <TrendIcon sx={{ color, fontSize: 16 }} />}
        <Typography variant="h6" sx={{ color, lineHeight: 1.2, minWidth: 0 }}>
          {value}
        </Typography>
      </Stack>
      {hint && (
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
          {hint}
        </Typography>
      )}
    </Stack>
  )
}
